/** The state of one step in a chat member's own step list. */
export type ChatStepState = 'todo' | 'in_progress' | 'done' | 'skipped'

/** One step the member has lined up. */
export type ChatStep = { title: string; state: ChatStepState }

/** The guard on a member's step list: how many steps, and how long a title may be (after trimming). */
export type ChatStepLimits = {
    maxSteps: number
    maxTitleChars: number
}

/**
 * The guard on a member's step list (#286): at most 20 steps, each title at most 200 characters once trimmed. A guard
 * the OS keeps, not a setting an enterprise tunes, so it is a constant rather than data. It also keeps the list the
 * member is reminded of at the start of every turn to roughly a thousand tokens or fewer.
 */
export const CHAT_STEP_LIMITS: ChatStepLimits = { maxSteps: 20, maxTitleChars: 200 }

/** Every state a step can be in, in the order a step moves through them; `skipped` is the step the person dropped. */
export const CHAT_STEP_STATES: readonly ChatStepState[] = ['todo', 'in_progress', 'done', 'skipped']

/** Whether `value` is exactly one of the four states: no trimming, no case folding. */
export function isChatStepState(value: unknown): value is ChatStepState {
    return typeof value === 'string' && (CHAT_STEP_STATES as readonly string[]).includes(value)
}
